import React, { useState } from "react";
import UseContext from "hooks/useContext";
import { ChevronDown } from "assets/icons";
import {
    fillText,
    formatShortDate,
    getCountText,
} from "pages/profil/perimeters/perimeterText";

const ARCHIVED_LIST_ID = "perimeters-archived-list";

const PerimeterArchivedSection = ({
    perimeters,
    onRestore,
    isRestoreDisabled,
}) => {
    const { language } = UseContext();
    const [isOpen, setIsOpen] = useState(false);

    if (perimeters.length === 0) return null;

    const getDetails = (perimeter) => {
        const archivedOn = formatShortDate(perimeter.archivedAt);
        return [
            archivedOn
                ? fillText(
                      language.getValue("perimeters.archived.archivedOn"),
                      {
                          date: archivedOn,
                      }
                  )
                : "",
            getCountText(
                language,
                "perimeters.archived.finishedMissions",
                Number(perimeter.usage?.finishedMissions) || 0
            ),
        ]
            .filter(Boolean)
            .join(" · ");
    };

    return (
        <section>
            <button
                type="button"
                aria-expanded={isOpen}
                aria-controls={isOpen ? ARCHIVED_LIST_ID : undefined}
                onClick={() => setIsOpen((open) => !open)}
                className="flex items-center gap-2 text-sm text-gray-500 hover:text-gray-700 focus:outline-none"
            >
                <span
                    aria-hidden="true"
                    className={`transition-transform ${
                        isOpen ? "" : "-rotate-90"
                    }`}
                >
                    <ChevronDown wh={16} color="#6B7280" />
                </span>
                {fillText(language.getValue("perimeters.archived.heading"), {
                    count: perimeters.length,
                })}
            </button>
            {isOpen && (
                <ul id={ARCHIVED_LIST_ID} className="mt-2">
                    {perimeters.map((perimeter) => (
                        <li
                            key={perimeter.id}
                            className="flex items-center justify-between gap-4 border-b border-gray-100 py-3"
                        >
                            <div className="flex min-w-0 flex-col gap-0.5">
                                <span
                                    className="truncate text-sm text-gray-600"
                                    title={perimeter.name}
                                >
                                    {perimeter.name}
                                </span>
                                <span className="text-sm text-gray-500">
                                    {getDetails(perimeter)}
                                </span>
                            </div>
                            <button
                                type="button"
                                aria-label={`${language.getValue(
                                    "perimeters.archived.restore"
                                )} ${perimeter.name}`}
                                disabled={isRestoreDisabled}
                                onClick={() => onRestore(perimeter)}
                                className="h-8 shrink-0 rounded-md border border-gray-200 bg-white px-3 text-sm text-gray-900 hover:bg-gray-50 focus:border-yellow-500 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50"
                            >
                                {language.getValue(
                                    "perimeters.archived.restore"
                                )}
                            </button>
                        </li>
                    ))}
                </ul>
            )}
        </section>
    );
};

export default PerimeterArchivedSection;
